import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

export const QUOTE_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'quote-block': (_, children) => `<blockquote>${children}</blockquote>`,
};
